import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TonePicker = _resolveComponent("TonePicker")!
  const _component_HueSlider = _resolveComponent("HueSlider")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Space = _resolveComponent("Space")!
  const _component_Popover = _resolveComponent("Popover")!

  return (_openBlock(), _createBlock(_component_Popover, {
    ref: "popover",
    show: _ctx.show,
    el: _ctx.el,
    "on-hide": _ctx.onHide,
    style: { width: '260px' }
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Space, {
        vertical: "",
        full: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TonePicker, {
            "model-value": _ctx.hsv,
            style: { height: '180px' },
            "onUpdate:modelValue": _ctx.onPickHSV
          }, null, 8 /* PROPS */, ["model-value", "onUpdate:modelValue"]),
          _createVNode(_component_HueSlider, {
            "model-value": _ctx.hsv,
            "onUpdate:modelValue": _ctx.onPickHSV
          }, null, 8 /* PROPS */, ["model-value", "onUpdate:modelValue"]),
          _createVNode(_component_Input, {
            block: "",
            small: "",
            "model-value": _ctx.stringValue,
            error: !_ctx.stringIsValid,
            "onUpdate:modelValue": _ctx.onInputString
          }, null, 8 /* PROPS */, ["model-value", "error", "onUpdate:modelValue"]),
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3 /* FORWARDED */
      })
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["show", "el", "on-hide"]))
}